export default {
  methods: {
    loadAddress () {
      return this.$axios.api.get('address-complete/address/' + this.mode)
    },
    
    updateAddress (address) {
      return this.$axios.api.post('address-complete/address/' + this.mode, address)
    }
  }
}